/**
 * Sanitizes a string for safe use with [innerHTML] or similar bindings.
 * Use for user input (e.g., names) to prevent layout breaking and XSS.
 *
 * Example:
 *   sanitizeHtml('><h1>hello') => '&gt;&lt;h1&gt;hello'
 *
 * This uses Angular's DomSanitizer with SecurityContext.HTML.
 *
 * Note: For most user input (like names), prefer escaping rather than allowing HTML.
 */
export function sanitizeHtml(input: string): string {
  // Angular's sanitizer removes dangerous HTML, but for names, we want to escape all tags.
  // We'll use a simple escape for < and > to prevent any HTML rendering.
  if (typeof input !== 'string') return '';
  return (
    input
      // Replace stray ampersands not part of an entity
      .replace(/&(?![a-zA-Z0-9#]+;)/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;')
  );
}
